import React, { useEffect, useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useReport } from '../../DataStore/ReportContext';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import MarkSheetSelector from '../../components/Academics/MarkSheet/MarkSheetSelector';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import printContent from '../../util/araknerdlib';
import { useReportView } from '../../DataStore/ReportViewContext';

const MarksheetPage = () => {
  const { marksheet, generateMarksheet, loadingMarksheet, reportId } = useReport();
  const {selectedReport} = useReportView();
  const reportRef = useRef();
  
  const handleExportToExcel = () => {
    if (!marksheet || !marksheet.marks_collection || !Array.isArray(marksheet.marks_collection.student_info)) return;

    const rows = marksheet.marks_collection.student_info.map((student, idx) => {
      const studentId = student.id;
      const row = {
        No: idx + 1,
        Name: student.full_name,
        Total: marksheet.marks_collection[studentId]?.total || "",
        Average: marksheet.marks_collection[studentId]?.average || "",
        Position: marksheet.marks_collection[studentId]?.position?.position || "",
      };

      marksheet.done_subjects.forEach(subject => {
        const subjectId = subject.subject_info.subject_id;
        row[subject.subject_info.abbreviation] = marksheet.marks_collection[studentId]?.[subjectId]?.subject_average || "-";
      });

      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Marksheet");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'marksheet.xlsx');
  };

  const PageActions = () => (
    <>
      <ActionDropdownItem iconClass="fa fa-print text-success" label="Print Marksheet" onClick={()=>printContent(reportRef, "Student Marksheet")} />
      <ActionDropdownItem iconClass="fa fa-file-excel text-warning" label="Export to Excel" onClick={handleExportToExcel} />
      <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={() => generateMarksheet(true, reportId)} />
    </>
  );

  return (
    <>
      <PageContainer>
        <MainContent>
          <PageTitle
            title="General Marksheets"
            description={selectedReport?.title || 'Generate and view student marksheets.'}
            iconClass="fa fa-table"
            PageActions={PageActions}
          />

          <div className="card mb-3">
            <div className="card-body" ref={reportRef}>

              {!reportId && (
                <Notification
                  type="info"
                  message="Please select a report from the Reports page to generate the marksheet."
                />
              )}

              {marksheet && marksheet !== "404" && <MarkSheetSelector marksheet={marksheet} />}
              {loadingMarksheet && <ActivityLoader />}
              {marksheet === "404" && <Notification type="warning" message="Failed to load marksheet" />}
            </div>
          </div>
        </MainContent>
      </PageContainer>
    </>
  );
};

export default MarksheetPage;
